import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

const getTabId = () => {
    const key = "kodelr-tab-id";
    let tabId = sessionStorage.getItem(key);

    if (!tabId) {
      tabId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(key, tabId);
    }

    return tabId;
};

function connectToSocket() {
    const token = localStorage.getItem("token");
    return openSocket(getBackendUrl(), {
      transports: ["websocket", "polling", "flashsocket"],
      query: {
        token: JSON.parse(token),
        tabId: getTabId(),
      },
    });
}

export default connectToSocket;
